import Grid from '@mui/material/Grid';
import Loading from 'components/Loading/Loading';
import {useHypoList} from "hooks/useHypo";
import {destructureDataForModalCards} from "helpers/Functions";
import CardHypo from "./CardHypo";
import BackToTopButtonModal from "components/Buttons/BackToTopButtonModal";
import React from "react";


export default function ListHypo(props) {
    const {daysAgo,patientId,topModalRef} = props;
    const {
        data,
        isLoading,
    } = useHypoList(patientId,daysAgo);

    return (
        <>
            {isLoading ? <Loading
                style={{ margin: '30px auto 0', display: 'flex',
                    justifyContent: 'center',height: '60px', width: '60px'}}/> :
                <Grid container>
                    {data?.map((glucoseCard, index) => {
                        const destructureData = destructureDataForModalCards(glucoseCard);
                        return (
                            <Grid container justifyContent='center' key={index}>
                                <Grid item xs={11} mb='16px'>
                                    <CardHypo cardData={destructureData}/>
                                </Grid>
                            </Grid>
                        )
                    })}
                    {data?.length>6 &&<BackToTopButtonModal topModalRef={topModalRef}/>}
                </Grid>
            }
        </>
    )
}
